import { ButtonProps } from 'antd';
import classnames from 'classnames';
import { ReactNode } from 'react';
// eslint-disable-next-line no-restricted-imports
import { Link as RRDLink, LinkProps as RRDLinkProps } from 'react-router-dom';
import styled from 'styled-components';

type LinkProps = RRDLinkProps & LinkAdditionalProps;

type LinkAdditionalProps = {
    button?: boolean;
    buttonType?: ButtonProps['type'];
    icon?: ReactNode;
};

export const Link = ({
    children,
    button,
    buttonType,
    className,
    icon,
    ...props
}: LinkProps) => {
    const classNames = classnames(className, {
        'ant-btn': button,
        'ant-btn-default': buttonType === 'default',
        'ant-btn-primary': buttonType === 'primary',
        'ant-btn-text': buttonType === 'text',
    });

    return (
        <StyledLink className={classNames} {...props}>
            {icon}
            <span>{children}</span>
        </StyledLink>
    );
};

const StyledLink = styled(RRDLink)`
    &.ant-btn {
        line-height: inherit !important;
        padding-top: 8px !important;
    }
`;
